import POIStep from "@/components/POI/POIStep/POIStep.vue";
import RewriteTextDialog from "@/components/Common/RewriteTextDialog/RewriteTextDialog.vue";
import { validateUrl } from "@/configuration/formConfigurations";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "License",
  components: { POIStep, RewriteTextDialog },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    validateUrl,
    showRewriteDialog: false,
    rewriteDialogField: null,
    promptsApiClientUrl: env.prompts_api_client_url,
    mainPeacock: "#00636C"
  }),
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    openRewriteDialog(field) {
      this.rewriteDialogField = field;
      this.showRewriteDialog = true;
    },
    getRewriteText() {
      if (!this.rewriteDialogField) return "";
      if (this.rewriteDialogField === "shortDescription") {
        return this.editedItem.shortDescription.description || "";
      } else if (this.rewriteDialogField === "description") {
        return this.editedItem.description.description || "";
      } else if (this.rewriteDialogField === "seasonalShortDescription") {
        return this.editedItem.shortDescription.seasonalDescription || "";
      } else if (this.rewriteDialogField === "seasonalDescription") {
        return this.editedItem.description.seasonalDescription || "";
      }
      return "";
    },
    handleRewriteApply(payload) {
      const { text } = payload;
      if (this.rewriteDialogField === "shortDescription") {
        this.editedItem.shortDescription.description = text;
      } else if (this.rewriteDialogField === "description") {
        this.editedItem.description.description = text;
      } else if (this.rewriteDialogField === "seasonalShortDescription") {
        this.editedItem.shortDescription.seasonalDescription = text;
      } else if (this.rewriteDialogField === "seasonalDescription") {
        this.editedItem.description.seasonalDescription = text;
      }
      this.showRewriteDialog = false;
      this.rewriteDialogField = null;
    }
  },
  computed: {
    isConferencePoi() {
      return this.editedItem.categoryType === "68b806188a951522ff1d56be"; // Kategorietyp 'Tagugn'
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isPromptUser() {
      if (this.isAdmin) {
        return true;
      }
      return this.$store.state.currentUser?.scopes?.includes("role:prompt");
    }
  }
};
